import { API_BASE_URL, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchEventAttendanceApi = (eventId) =>
    getRequest({
        url: `${API_BASE_URL}/api/events/${eventId}/attendance`,
        token: getToken(),
        uid: getUid(),
    });

export const bulkUpdateEventAttendanceApi = (eventId, items) =>
    postRequest({
        url: `${API_BASE_URL}/api/events/${eventId}/attendance/bulk`,
        data: { items },
        token: getToken(),
        uid: getUid(),
    });

export const declareMyEventAbsenceApi = (eventId, payload) =>
    postRequest({
        url: `${API_BASE_URL}/api/events/${eventId}/attendance/me/absence`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });
